import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import { ActionAllowed } from '../rbac/rbacutil';
import { rbacactions } from '../rbac/rbacrules';
import EditIcon from '@mui/icons-material/Edit';
import { orderBy } from 'lodash';
import { useTranslation } from 'react-i18next';

const styles = {
    table: { width: '100%' },
    emptytable: { width: '100%', p: '10px', fontSize: '0.75em' },
    withPadding: { p: '1em' },
    sectionDesktop: { display: { xs: 'none', md: 'flex' } },
    sectionMobile: { display: { xs: 'flex', md: 'none' } },
};

export default function ProductRequests(props) {
    const userProfile = useSelector((state) => state.authentication.userProfile);
    const history = useHistory();
    const [sortBy, setSortBy] = React.useState('added');
    const [sortOrder, setSortOrder] = React.useState('desc');
    const productRequests = props.productRequests;
    const { t } = useTranslation();

    const editProduct = (productId) => {
        history.push(`/product/edit/${productId}`);
    };

    const changeSort = (sortByClicked) => {
        if (sortByClicked === sortBy) {
            if (sortOrder === 'asc') {
                setSortOrder('desc');
            } else {
                setSortOrder('asc');
            }
        } else {
            setSortBy(sortByClicked);
            setSortOrder('desc');
        }
    };

    const sortList = (requests) => {
        return orderBy(requests, [sortBy], [sortOrder]);
    };

    const sortMobile = (requests) => {
        return orderBy(requests, ['added'], ['desc']);
    };

    return (
        <Grid item container xs={12}>
            <Paper sx={styles.table}>
                <Grid item sx={styles.withPadding}>
                    <h5>{t('product.productRequests')}</h5>
                    {(!productRequests || productRequests.length === 0) && (
                        <span>{t('product.noProductRequests')}</span>
                    )}
                </Grid>
                {productRequests && productRequests.length > 0 && (
                    <div>
                        <Box sx={styles.sectionDesktop}>
                            <Table sx={styles.table}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <TableSortLabel
                                                active={sortBy === 'productCode'}
                                                direction={sortOrder}
                                                onClick={() => changeSort('productCode')}>
                                                {' '}
                                                {t('product.code')}
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>
                                            <TableSortLabel
                                                active={sortBy === 'productName'}
                                                direction={sortOrder}
                                                onClick={() => changeSort('productName')}>
                                                {' '}
                                                {t('product.name')}
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>
                                            <TableSortLabel
                                                active={sortBy === 'added'}
                                                direction={sortOrder}
                                                onClick={() => changeSort('added')}>
                                                {' '}
                                                {t('product.addedDate')}
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>
                                            <TableSortLabel
                                                active={sortBy === 'addedByUser'}
                                                direction={sortOrder}
                                                onClick={() => changeSort('addedByUser')}>
                                                {' '}
                                                {t('product.addedBy')}
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {sortList(productRequests).map((f) => (
                                        <TableRow key={f.id}>
                                            <TableCell>{f.productCode}</TableCell>
                                            <TableCell>{f.productName}</TableCell>
                                            <TableCell>{f.added.format('DD.MM.YYYY')}</TableCell>
                                            <TableCell>
                                                {f.addedByUser !== 'Automatic updater' ? f.addedByUser : '-'}
                                            </TableCell>
                                            <TableCell>
                                                <Button
                                                    disabled={!ActionAllowed(rbacactions.ModifyProduct, userProfile)}
                                                    variant="contained"
                                                    onClick={() => editProduct(f.id)}
                                                    name="edit-product"
                                                    startIcon={<EditIcon />}>
                                                    {t('buttons.edit')}
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                        <Box sx={styles.sectionMobile}>
                            <Table sx={styles.table}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{t('general.product')}</TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {sortMobile(productRequests).map((f) => (
                                        <TableRow key={f.id}>
                                            <TableCell>
                                                {f.productCode}
                                                <br />
                                                {f.productName}
                                                <br />
                                                {f.added.format('DD.MM.YYYY')}
                                                <br />
                                                {f.addedByUser !== 'Automatic updater' ? f.addedByUser : '-'}
                                            </TableCell>
                                            <TableCell>
                                                <Button
                                                    disabled={!ActionAllowed(rbacactions.ModifyProduct, userProfile)}
                                                    variant="contained"
                                                    onClick={() => editProduct(f.id)}
                                                    name="edit-product"
                                                    startIcon={<EditIcon />}>
                                                    {t('buttons.edit')}
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </div>
                )}
            </Paper>
        </Grid>
    );
}
